
export const BrowserAPI = function () {
  const saveToLocalStorage = function(id, data) {
    if (typeof(id) != 'string') {
      throw Error(
        "BrowserAPI.saveToLocalStorage: Id has to be a string but is of type '"+
        typeof(id)+"'"
      );
    }
    if ((typeof(data) != 'object') || (data === null)) {
      throw Error(
        "BrowserAPI.saveToLocalStorage: Data has to be a non null object but is of type '"+
        typeof(data)+"'"
      ); 
    }
    const parsedData = JSON.stringify(data);
    localStorage.setItem(id, parsedData);
  }

  const saveToSessionStorage = function(id, data) {
    if (typeof(id) != 'string') {
      throw Error(
        "BrowserAPI.saveToSessionStorage: Id has to be a string but is of type '"+
        typeof(id)+"'"
      );
    }
    if ((typeof(data) != 'object') || (data === null)) {
      throw Error(
        "BrowserAPI.saveToSessionStorage: Data has to be a non null object but is of type '"+
        typeof(data)+"'"
      ); 
    }
    const parsedData = JSON.stringify(data);
    sessionStorage.setItem(id, parsedData);
  } 

  const getFromLocalStorage = function(id) {
    if (typeof(id) != 'string') {
      throw Error(
        "BrowserAPI.getFromLocalStorage: Id has to be a string but is of type '"+
        typeof(id)+"'"
      );
    } 
    const dataString = localStorage.getItem(id);
    if (dataString === null) {
      return null;
    }
    try {
      const data = JSON.parse(dataString);
      if ((typeof(data) != 'object') || (data === null)) {
        throw Error(
          "BrowserAPI.getFromLocalStorage: Restored data denied since it was not an object or null'"+
          typeof(data)+"'"
        ); 
      } 
      return data;
    } catch(e) {
      localStorage.removeItem(id);
    }
    return null;
  }

  const getFromSessionStorage = function(id) {
    if (typeof(id) != 'string') {
      throw Error(
        "BrowserAPI.getFromSessionStorage: Id has to be a string but is of type '"+
        typeof(id)+"'"
      );
    } 
    const dataString = sessionStorage.getItem(id);
    if (dataString === null) {
      return null;
    }
    try {
      const data = JSON.parse(dataString);
      if ((typeof(data) != 'object') || (data === null)) {
        throw Error(
          "BrowserAPI.getFromSessionStorage: Restored data denied since it was not an object or null'"+
          typeof(data)+"'"
        ); 
      } 
      return data;
    } catch(e) {
      localStorage.removeItem(id);
    }
    return null;
  } 

  return {
    saveToLocalStorage,
    saveToSessionStorage,
    getFromLocalStorage,
    getFromSessionStorage
  }
};
export const browser = BrowserAPI();